module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-bottom-01.2@2x.792f0f5c.jpg";